import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Extractor Job Schedules 
export const postExtJobSchedulesRequest = (payload: types.IExtJobScheduleParams): types.PostExtJobSchedulesRequest => ({
    type: actionTypes.POST_EXTJOBSCHEDULES_REQUEST,
    payload
});

export const postExtJobSchedulesSuccess = (payload: types.IPostExtJobSchedSuccessPayload): types.PostExtJobSchedulesSuccess => ({
    type: actionTypes.POST_EXTJOBSCHEDULES_SUCCESS,
    payload
});

export const postExtJobSchedulesFailure = (payload: types.IPostExtJobSchedFailurePayload): types.PostExtJobSchedulesFailure => ({
    type: actionTypes.POST_EXTJOBSCHEDULES_FAILURE,
    payload
});

// Put Job Schedules

export const putExtJobSchedulesRequest = (
    jobId: string,
    payload: types.IJobSchedulesPutReq
): types.PutJobSchedulesRequest => ({
    type: actionTypes.PUT_EXTJOBSCHEDULES_REQUEST,
    jobId,
    payload
});

export const putExtJobSchedulesSuccess = (
    payload: types.IPutJobSchedulesSuccessPayload
): types.PutJobSchedulesSuccess => ({
    type: actionTypes.PUT_EXTJOBSCHEDULES_SUCCESS,
    payload,
});

export const putExtJobSchedulesFailure = (
    payload: types.IPutJobSchedulesFailurePayload
): types.PutJobSchedulesFailure => ({
    type: actionTypes.PUT_EXTJOBSCHEDULES_FAILURE,
    payload,
});

// DELETE Jobs

export const deleteExtJobSchedulesReq = (
    params: string
): types.DeleteJobSchedulesRequest => ({
    type: actionTypes.DELETE_EXTJOBSCHEDULES_REQUEST,
    params,
});

export const deleteExtJobSchedulesSuccess = (
    success: types.IDeleteJobSchedulesSuccess
): types.DeleteJobSchedulesSuccess => ({
    type: actionTypes.DELETE_EXTJOBSCHEDULES_SUCCESS,
    success,
});

export const deleteExtJobSchedulesFailure = (
    payload: types.IDeleteJobSchedulesFailurePayload
): types.DeleteJobSchedulesFailure => ({
    type: actionTypes.DELETE_EXTJOBSCHEDULES_FAILURE,
    payload,
});

